import Int32LookupResourceListResultModel from '../../generated/types/model/resource/Int32LookupResourceListResultModel';

export default class Int32LookupResourceListResultViewModel extends Int32LookupResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
